document.getElementById('addDonation').addEventListener('click', donateOnce);
document.getElementById('addDonationMonthly').addEventListener('click', donateMonthly);
document.getElementById('addDonationWeekly').addEventListener('click', donateWeekly);

function addDonation(recurring) {
  try {
    const formData  = new FormData();

    formData.append('product-id', 6986506240067);
    formData.append('form_type', 'product');
    formData.append('quantity', 1);
    let selectedOption = false;

    if (document.getElementById('ten-dol').checked) {
      formData.append('Amount', 10);
      formData.append('id', document.getElementById('ten-dol').value);
      selectedOption = true;
    } else if (document.getElementById('twelve-dol').checked) {
      formData.append('Amount', 12);
      formData.append('id', document.getElementById('twelve-dol').value);
      selectedOption = true;
    } else if (document.getElementById('thirtyfive-dol').checked) {
      formData.append('Amount', 35);
      formData.append('id', document.getElementById('thirtyfive-dol').value);
      selectedOption = true;
    } else if (document.getElementById('seventyFive-dol').checked) {
      formData.append('Amount', 75);
      formData.append('id', document.getElementById('seventyFive-dol').value);
      selectedOption = true;
    }

    if (recurring == 'MONTHLY') {
      formData.append('selling_plan', 1479934019);
    } else if (recurring == 'WEEKLY') {
      formData.append('selling_plan', 1828192323);
    }

    if (selectedOption) {
      fetch(window.Shopify.routes.root + 'cart/add', {
        method: 'POST',
        body: formData,
      }).then(function() {
        document.getElementById('updateCart').click();
      });
      
    }
  } catch (err) {
    console.error(err);
  }
}

function donateOnce() {
  addDonation(false);
}

function donateMonthly() {
  addDonation('MONTHLY');
}

function donateWeekly() {
  addDonation('WEEKLY');
}